export const cityLinkTitles = {
	climateControlled: 'Climate Controlled',
	'24HourAccess': '24 Hour Access',
	carStorage: 'Car Storage',
	boatStorage: 'Boat Storage',
	rvStorage: 'RV Storage',
};

export const amenityObject = {
	'climate-controlled': 'Climate-Controlled',
	'24-hour-access': '24-Hour',
	'drive-up-self-storage': 'Drive-Up',
	electricity: 'Electricity',
	'free-truck-rental': 'Free Truck Rental',
	'mini-self-storage': 'Mini',
	'small-self-storage-units': 'Small',
	'medium-self-storage-units': 'Medium',
	'large-self-storage-units': 'Large',
	'self-storage-lockers': 'Lockers',
	rv: 'RV',
	car: 'Car',
	boat: 'Boat',
	'': '',
};

/**
 * FAQ H2 title suffixes by amenity/vehicle type per SEO spec.
 * Pattern: "Frequently Asked Questions About {city}, {state} {suffix}"
 */
export const faqTitleSuffixMap = {
	// Amenity landing pages (ALPs)
	'24-hour-access': '24 Hour Self Storage',
	'climate-controlled': 'Climate Controlled Self Storage',
	'drive-up-self-storage': 'Drive Up Self Storage',
	electricity: 'Self Storage With Electricity',
	'free-truck-rental': 'Self Storage With Free Truck Rentals',
	// Size landing pages (SLPs)
	'mini-self-storage': 'Mini Self Storage',
	'self-storage-lockers': 'Self Storage Lockers',
	'small-self-storage-units': 'Small Self Storage Units',
	'medium-self-storage-units': 'Medium Self Storage Units',
	'large-self-storage-units': 'Large Self Storage Units',
	// Vehicle landing pages (VLPs)
	boat: 'Boat Self Storage',
	car: 'Car Self Storage',
	rv: 'RV Self Storage',
	// Default CLP
	'': 'Self Storage',
};
